module.exports = __webpack_public_path__ + "static/media/success-tickets-2.c1485d2e.svg";